import { ColorPaletteProp } from '@healthinal/ui';
import { ScreeningAssessmentResult, ScreeningCaseStatus, ScreeningClientType } from '../api/created/screening.ts';

const SCREENING_ASSESSMENT_RESULT_LABELS: Record<ScreeningAssessmentResult, string> = {
 
  [ScreeningAssessmentResult.XRAY_PERFORMED]: 'Röntgen durchgeführt',
  [ScreeningAssessmentResult.INFECTED]: 'Infiziert',
  [ScreeningAssessmentResult.NOT_INFECTED]: 'Nicht infiziert',
  [ScreeningAssessmentResult.SICK]: 'Erkrankt',
  [ScreeningAssessmentResult.NOT_SHOW_UP]: 'Nicht erschienen',
  [ScreeningAssessmentResult.REFUSED_TEST]: 'Test verweigert',
  [ScreeningAssessmentResult.GONE_HIDING]: 'Untergetaucht',
  [ScreeningAssessmentResult.STATUS_AFTER_TB]: 'Status nach TB',
  [ScreeningAssessmentResult.STATUS_AFTER_TBI]: 'Status nach TBI',
};

export function getScreeningAssessmentResultName(result: ScreeningAssessmentResult): string {
  return SCREENING_ASSESSMENT_RESULT_LABELS[result];
}

export function getScreeningCaseStatusName(status: ScreeningCaseStatus): string {
  switch (status) {
    case 'OPEN':
      return 'Offen';
    case 'CLOSED':
      return 'Geschlossen';
  }
}

export function getScreeningClientTypeName(clientType: ScreeningClientType | string | null | undefined): string {
  switch (clientType) {
    case ScreeningClientType.BAZ_ZURICH:
      return 'BAZ Zürich';
    case ScreeningClientType.SELF_REFERRAL:
      return 'Selbstmelder';
    case ScreeningClientType.OTHER:
      return 'Andere';
    default:
      return clientType ?? '';
  }
}

export function getScreeningAssessmentResultFromStatus(status: string): ScreeningAssessmentResult | null {
  switch (status) {
    case 'RESULT_INFECTED':
      return ScreeningAssessmentResult.INFECTED;
    case 'RESULT_NOT_INFECTED':
      return ScreeningAssessmentResult.NOT_INFECTED;
    case 'RESULT_SICK':
      return ScreeningAssessmentResult.SICK;
    case 'NOT_SHOW_UP':
      return ScreeningAssessmentResult.NOT_SHOW_UP;
    case 'REFUSED_TEST':
      return ScreeningAssessmentResult.REFUSED_TEST;
    case 'GONE_HIDING':
      return ScreeningAssessmentResult.GONE_HIDING;
    case 'STATUS_AFTER_TB':
      return ScreeningAssessmentResult.STATUS_AFTER_TB;
    case 'STATUS_AFTER_TBI':
      return ScreeningAssessmentResult.STATUS_AFTER_TBI;
    case 'XRAY_PERFORMED':
      return ScreeningAssessmentResult.XRAY_PERFORMED;
    default:
      return null;
  }
}

export function getScreeningAssessmentStatusName(status: string): string {
  switch (status) {
    case 'PENDING':
      return 'Einschätzung nötig';
    case 'NO_UU_NEEDED':
      return 'keine UU nötig';
    case 'RESULT_INFECTED':
      return 'Infiziert';
    case 'RESULT_NOT_INFECTED':
      return 'Nicht infiziert';
    case 'RESULT_SICK':
      return 'Erkrankt';
    case 'NOT_SHOW_UP':
      return 'Nicht erschienen';
    case 'REFUSED_TEST':
      return 'Test verweigert';
    case 'GONE_HIDING':
      return 'Untergetaucht';
    case 'STATUS_AFTER_TB':
      return 'Status nach TB';
    case 'STATUS_AFTER_TBI':
      return 'Status nach TBI';
    case 'XRAY_PERFORMED':
        return 'Röntgen durchgeführt';
    default:
      return status;
  }
}

export function getScreeningAssessmentStatusColor(status: string): ColorPaletteProp {
  switch (status) {
    case 'PENDING':
    case 'INCUBATION_PERIOD':
      return 'danger';
    case 'NOT_NEEDED':
    case 'RESULT_INDETERMINATE':
    case 'RESULT_NEGATIVE':
    case 'RESULT_NOT_INFECTED':
    case 'NO_UU_NEEDED':
    case 'XRAY_PERFORMED':
      return 'primary';
    case 'RESULT_POSITIVE':
    case 'RESULT_INFECTED':
    case 'RESULT_SICK':
      return 'danger';
    default:
      return 'neutral';
  }
}
